export default __webpack_public_path__ + "static/media/l-phone.25b38fc4.svg";